module.exports = __webpack_public_path__ + "static/jest-setup-d6f08c80eeac34198d2d16f29f8b395e.png";